import { useMemo } from 'react';
import { useSupplierItemSelectorListQuery } from 'api';

export const useSupplierItemMapping = (id: string): Record<string, any> => {
  const { data: supplierItems = [] } = useSupplierItemSelectorListQuery({ purchaseRequestId: id }, { skip: !id });
  const supplierItemMapping: Record<string, { name: string; supplierOfferId: string }> = useMemo(() => {
    const mapping: Record<string, { name: string; supplierOfferId: string }> = {};
    supplierItems.forEach((i: { name: string; supplierOfferId: string }) => {
      mapping[i.supplierOfferId] = i;
    });
    return mapping;
  }, [supplierItems]);

  return {
    supplierItemMapping,
  };
};
